import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { BuilderContextProvidersRegistry } from './builderContextProvidersRegistry'
import { BuilderContextProvidersLoader } from './builderContextProvidersLoader'
import { BuilderContextProvidersPageWillMountHandler } from './builderContextProvidersPageWillMountHandler'
import {
	BuilderContextProvidersAttachedStoreSymbol,
	ContextProviderLoaderSymbol,
	ContextProviderRegistrySymbol
} from './symbols'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { BuilderContextProvidersAttachedStore } from './builderContextProvidersAttachedStore'

export const site: ContainerModuleLoader = (bind) => {
	bind(ContextProviderRegistrySymbol).to(BuilderContextProvidersRegistry)
	bind(ContextProviderLoaderSymbol).to(BuilderContextProvidersLoader)
	bind(BuilderContextProvidersAttachedStoreSymbol).to(BuilderContextProvidersAttachedStore)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(BuilderContextProvidersPageWillMountHandler)
}
